// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js!./variables.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../dist/images/park.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html, body {
  height: 100%;
  margin: 0;
  padding: 0;
  font-family: var(--font);
}

body {
  display: flex; 
  flex-direction: column;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) center/cover;
}

header {
  width: 100vw;
  display: flex;
  align-items: center;
  background-color: var(--secondary-accent-color);
  height: 45px;
  padding: 10px 20px;

  .dog-icon {
    width: 50px;
    margin-right: auto;
  }

}

nav {
  background-color: var(--secondary-accent-color);

  ul {
    list-style: none;
    display: flex;
    margin: 0;
    padding: 10;
    margin-left: auto;
    display: flex;
    justify-content: space-between;
    padding-right: 50px;
    font-weight: bold;
    color: white;
    font-size: 25px;
    cursor: pointer;

    li {
      margin-left: 55px;
    }
  }
}

main {
  display: flex;
  flex-direction: column;
  overflow: auto;
}

.overview {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  max-width: 100%;
  height: 600px;

  h1 {
    font-weight: 400;
  }

  img {
    height: 255px;
    width: 255px;
    border-radius: 50%;
    border-color: #3F8DA7;
    border-width: 3px;
    border-style: solid;
    margin-bottom: 20px;
  } 
}


#what-are-dogs {
  display: flex;
  align-items: center;
  text-align: center;
  flex-wrap: wrap;
  justify-content: center; 
  padding: 3px 5px;
  margin-top: 10px;
  margin-bottom: 40px;
  background-color: #FFFFFF;
  color: #3F8DA7;
  border-width: var(--button-border-width);
  border-color: #3F8DA7;
  border-style: solid; 
  font-family: var(--font);
  font-size: var(--dog-font-size);
  width: var(--dog-width);
  height: var(--dog-height);
  white-space: nowrap;
  }



.how-what-facts {
  display: flex;
  flex-direction: wrap;
  justify-content: space-between;
  align-items: center;
  padding-top: 50px;
  background-color: white;
  width: 100%;
  height: 485px;
  padding: 20px;
  box-sizing: border-box;

  img {
    width: 180px;
    height: 180px;
    border-radius: 50%;
    border-color: #3F8DA7;
    border-width: 3px;
    border-style: solid;
    margin-bottom: 20px;
  }

  button {
    padding: 10px px;
    background-color: var(--button-background);
    color: var(--button-color);
    border-width: var(--button-border-width);
    border-color: #3F8DA7;
    border-style: solid;
    font-family: var(--font);
    font-size: 20px;
    cursor: pointer;
  }
}

.how-what-facts h3 {
  margin-top: 0;
}

.dog-stories { 
  align-items: center;
  text-align: center;
  width: 100%;
  display: flex;
  flex-direction: column;
  flex: 1;

  .dog-information {
    padding-left: 30px;
    padding-right: 30px;
    margin-left: 20px;
    margin-right: 20px;
  }  

  .info-headers {
    font-weight: 500;
    padding-top: 10px;
  
  }
}

footer { 
  height: 180px;
  background-color: #3F8DA7;
  display: flex;
  flex-direction: column; 
  justify-content: center;
  align-items: center;
  text-align: center;
  color: white;
}

.footer-content {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  max-width: 100%;
  padding: 20px;
  box-sizing: border-box;

  h2 {
    margin-bottom: 20px;
    font-size: 20px;
    font-weight: 500;
    display: flex;
    padding-left: 20px;
    padding-bottom: 5px;
    align-items: center;
    margin-left: 35px;
  }

  h3 {
    margin-top: 10px;
    text-decoration: underline;
    font-weight: 500;
    display: flex;
    padding-left: 20px;
    padding-bottom: 5px;
    align-items: center;
    margin-left: 35px;
  }

  .facebook-logo, .twitter-logo, .instagram-logo, .linkedIn-logo {
    padding-left: 50px;
    padding-bottom: 20px;
    cursor: pointer;
  }
} 

.social-media-links {
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    margin: 0 10px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/css/index.css"],"names":[],"mappings":"AAEA;EACE,YAAY;EACZ,SAAS;EACT,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gEAA0D;AAC5D;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,+CAA+C;EAC/C,YAAY;EACZ,kBAAkB;;EAElB;IACE,WAAW;IACX,kBAAkB;EACpB;;AAEF;;AAEA;EACE,+CAA+C;;EAE/C;IACE,gBAAgB;IAChB,aAAa;IACb,SAAS;IACT,WAAW;IACX,iBAAiB;IACjB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,iBAAiB;IACjB,YAAY;IACZ,eAAe;IACf,eAAe;;IAEf;MACE,iBAAiB;IACnB;EACF;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,aAAa;;EAEb;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,YAAY;IACZ,kBAAkB;IAClB,qBAAqB;IACrB,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;EACrB;AACF;;;AAGA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,wCAAwC;EACxC,qBAAqB;EACrB,mBAAmB;EACnB,wBAAwB;EACxB,+BAA+B;EAC/B,uBAAuB;EACvB,yBAAyB;EACzB,mBAAmB;EACnB;;;;AAIF;EACE,aAAa;EACb,oBAAoB;EACpB,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,uBAAuB;EACvB,WAAW;EACX,aAAa;EACb,aAAa;EACb,sBAAsB;;EAEtB;IACE,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,qBAAqB;IACrB,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,0CAA0C;IAC1C,0BAA0B;IAC1B,wCAAwC;IACxC,qBAAqB;IACrB,mBAAmB;IACnB,wBAAwB;IACxB,eAAe;IACf,eAAe;EACjB;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,OAAO;;EAEP;IACE,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;;EAEnB;AACF;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,sBAAsB;;EAEtB;IACE,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,0BAA0B;IAC1B,gBAAgB;IAChB,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;EACjB;AACF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;;EAEnB;IACE,cAAc;EAChB;AACF","sourcesContent":["@import 'variables';\n\nhtml, body {\n  height: 100%;\n  margin: 0;\n  padding: 0;\n  font-family: var(--font);\n}\n\nbody {\n  display: flex; \n  flex-direction: column;\n  background: url('../../dist/images/park.jpg') center/cover;\n}\n\nheader {\n  width: 100vw;\n  display: flex;\n  align-items: center;\n  background-color: var(--secondary-accent-color);\n  height: 45px;\n  padding: 10px 20px;\n\n  .dog-icon {\n    width: 50px;\n    margin-right: auto;\n  }\n\n}\n\nnav {\n  background-color: var(--secondary-accent-color);\n\n  ul {\n    list-style: none;\n    display: flex;\n    margin: 0;\n    padding: 10;\n    margin-left: auto;\n    display: flex;\n    justify-content: space-between;\n    padding-right: 50px;\n    font-weight: bold;\n    color: white;\n    font-size: 25px;\n    cursor: pointer;\n\n    li {\n      margin-left: 55px;\n    }\n  }\n}\n\nmain {\n  display: flex;\n  flex-direction: column;\n  overflow: auto;\n}\n\n.overview {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  max-width: 100%;\n  height: 600px;\n\n  h1 {\n    font-weight: 400;\n  }\n\n  img {\n    height: 255px;\n    width: 255px;\n    border-radius: 50%;\n    border-color: #3F8DA7;\n    border-width: 3px;\n    border-style: solid;\n    margin-bottom: 20px;\n  } \n}\n\n\n#what-are-dogs {\n  display: flex;\n  align-items: center;\n  text-align: center;\n  flex-wrap: wrap;\n  justify-content: center; \n  padding: 3px 5px;\n  margin-top: 10px;\n  margin-bottom: 40px;\n  background-color: #FFFFFF;\n  color: #3F8DA7;\n  border-width: var(--button-border-width);\n  border-color: #3F8DA7;\n  border-style: solid; \n  font-family: var(--font);\n  font-size: var(--dog-font-size);\n  width: var(--dog-width);\n  height: var(--dog-height);\n  white-space: nowrap;\n  }\n\n\n\n.how-what-facts {\n  display: flex;\n  flex-direction: wrap;\n  justify-content: space-between;\n  align-items: center;\n  padding-top: 50px;\n  background-color: white;\n  width: 100%;\n  height: 485px;\n  padding: 20px;\n  box-sizing: border-box;\n\n  img {\n    width: 180px;\n    height: 180px;\n    border-radius: 50%;\n    border-color: #3F8DA7;\n    border-width: 3px;\n    border-style: solid;\n    margin-bottom: 20px;\n  }\n\n  button {\n    padding: 10px px;\n    background-color: var(--button-background);\n    color: var(--button-color);\n    border-width: var(--button-border-width);\n    border-color: #3F8DA7;\n    border-style: solid;\n    font-family: var(--font);\n    font-size: 20px;\n    cursor: pointer;\n  }\n}\n\n.how-what-facts h3 {\n  margin-top: 0;\n}\n\n.dog-stories { \n  align-items: center;\n  text-align: center;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n\n  .dog-information {\n    padding-left: 30px;\n    padding-right: 30px;\n    margin-left: 20px;\n    margin-right: 20px;\n  }  \n\n  .info-headers {\n    font-weight: 500;\n    padding-top: 10px;\n  \n  }\n}\n\nfooter { \n  height: 180px;\n  background-color: #3F8DA7;\n  display: flex;\n  flex-direction: column; \n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  color: white;\n}\n\n.footer-content {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  max-width: 100%;\n  padding: 20px;\n  box-sizing: border-box;\n\n  h2 {\n    margin-bottom: 20px;\n    font-size: 20px;\n    font-weight: 500;\n    display: flex;\n    padding-left: 20px;\n    padding-bottom: 5px;\n    align-items: center;\n    margin-left: 35px;\n  }\n\n  h3 {\n    margin-top: 10px;\n    text-decoration: underline;\n    font-weight: 500;\n    display: flex;\n    padding-left: 20px;\n    padding-bottom: 5px;\n    align-items: center;\n    margin-left: 35px;\n  }\n\n  .facebook-logo, .twitter-logo, .instagram-logo, .linkedIn-logo {\n    padding-left: 50px;\n    padding-bottom: 20px;\n    cursor: pointer;\n  }\n} \n\n.social-media-links {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  img {\n    margin: 0 10px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
